import React, { Component } from "react";
import { Button, Modal } from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  CloseOutlined,
} from "@ant-design/icons";
import config from "../config";

class PythonMessageAlert extends Component {
  state = {
    visible: false,
  };

  show = () => {
    this.setState({ visible: true });
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  handleLinkClick = () => {
    this.handleClose();
  };

  render() {
    return (
      <>
        <Modal
          maskClosable={false}
          title={
            <div className="deleteModalTitle">
              <span>Alert</span>
              <CloseOutlined
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.handleClose()}
              />
            </div>
          }
          className={
            this.props.message === "success" ? "addDeptModal" : "deleteModal"
          }
          description="Python Report "
          open={this.state.visible}
          footer={null}
          centered
          width={400}
          closable={false}
        >
          <div style={{ textAlign: "center" }}>
            {this.props.message === "success" ? (
              <CheckCircleFilled
                style={{ fontSize: "36px", color: "#52c41a" }}
              />
            ) : (
              <CloseCircleFilled
                style={{ fontSize: "36px", color: "rgba(217, 45, 32, 0.7)" }}
              />
            )}

            {this.props.message === "success" ? (
              <h3 style={{ marginTop: "12px", fontSize: "18px" }}>
                Report Scheduled
              </h3>
            ) : (
              <h3 style={{ marginTop: "12px", fontSize: "18px" }}>
                Something went wrong
              </h3>
            )}
            {this.props.message === "success" ? (
              <p style={{ fontSize: "14px", color: "#555", lineHeight: "1.5" }}>
                The report will be generated shortly.
                <br />
                You can check its status in the{" "}
                <a
                  // href="http://localhost:3000/PythonReportList"
                  href={config.baseURL.replace(/\/api\/?$/, '') + "/PythonReportList"}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this.handleLinkClick}
                  style={{ color: "#1677ff" }}
                >
                  pending report list
                </a>
                .
              </p>
            ) : (
              <p style={{ fontSize: "14px", color: "#555", lineHeight: "1.5" }}>
                Failed to download the report. Please try again.
              </p>
            )}

            <div
              className={
                this.props.message === "success"
                  ? "addDeptModalButtons"
                  : "deleteModalButtons"
              }
            >
              <Button
                className={
                  this.props.message === "success"
                    ? "addDeptModalOkButton"
                    : "deleteModalOkButton"
                }
                onClick={this.handleClose}
                style={{ marginTop: "20px", padding: "0 28px", height: "40px" }}
                size="small"
              >
                OK
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default PythonMessageAlert;
